export default "__VITE_ASSET__BcHsJiar__"